import styled from "styled-components";

interface BackgroundProps {
  $active: boolean;
}

export const Wrapper = styled.div<BackgroundProps>`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1001;
  padding-top: 60px;
  opacity: 0;
  visibility: hidden;
  transition: transform .25s, opacity .25s, visibility .25s;
  overflow-y: auto;

  ${({ $active }) => $active && `
    opacity: 1;
    visibility: visible;
  `};
}`;

export const Modal = styled.div<BackgroundProps>`
  padding: 12px;
  display: flex;
  flex-direction: column;
  width: 957px;
  height: calc(100vh - 100px);
  min-height: 500px;
  max-height: 700px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0px 1px 40px 0px rgba(0, 0, 0, 0.25);
  margin: auto;
  position: relative;
  z-index: 1;
}`;

export const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeadTitle = styled.span`
  color: var(--Fill-Button-Prussian-blue, var(--Header, #112538));
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 1.68px;
`;

export const CloseBtn = styled.button`
  display: flex;
  width: 24px;
  height: 24px;
  border: none;
  background-color: transparent;
  padding: 0;
  transition: transform 0.25s;

  svg .st0 {
    fill: #8E97A3;
  }

  &:hover {
    transform: rotate(180deg);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;  
`;

export const HeaderCol = styled.div<{ $left?: boolean; $right?: boolean; }>`
  display: flex;
  gap: 12px;

  ${({ $left }) => $left && `
    flex-direction: column;
  `}
`;

export const Title = styled.span`
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: capitalize;
`;

export const Text = styled.span`
  color: var(--Neutral-700, #404040);
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: 14px;
  line-height: 20px;
  max-width: 466px;
`;

export const Hr = styled.div`
  width: 100%;
  min-height: 1px;
  background: #CED0D4;
  margin: 12px 0;
`;

export const Body = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  overflow: hidden;
  max-height: 500px;
  position: relative;
`;

export const SpinnerWrapper = styled.div`
  background-color: rgba(255,255,255,0.5);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
`;

export const ChartArea = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Legend = styled.div`
  width: 380px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 20px;
  overflow-y: auto;

  ::-webkit-scrollbar:vertical {
    width: 6px !important;
  }

  ::-webkit-scrollbar-track {
    background: transparent !important ;
  }

  ::-webkit-scrollbar-thumb:vertical {
    background-color: #acb4bc;
    border-radius: 100px;
  }
`;

export const Background = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(79, 89, 102, 0.50);
`;
